import {useCallback, useEffect, useState} from 'react';
import {useParams} from 'react-router-dom';
import {
  GoogleMap,
  Marker,
  withGoogleMap,
  withScriptjs,
} from 'react-google-maps';
import {isMobile} from 'react-device-detect';
import ReactTouchEvents from 'react-touch-events';

const MapView = withScriptjs(withGoogleMap(props => {

  const [lat, setLat] = useState(null);
  const [lng, setLng] = useState(null);
  const [name, setName] = useState(null);
  const [phone, setPhone] = useState(null);
  const [status, setStatus] = useState(null);
  const [statusCode, setStatusCode] = useState(0);
  const [message, setMessage] = useState(0);
  const [detail, setDetail] = useState(0);
  const [data, setData] = useState(0);
  const {id} = useParams();

  const apiUri = process.env.REACT_APP_API_URL;

  const action = a => {
    const actionType = {action: a};
    console.log('action', a);
    fetch(`${apiUri}/api/emergencyContactAction`, {
      method: 'POST',
      mode: 'cors',
      cache: 'no-cache',
      credentials: 'same-origin',
      headers: {
        'Content-Type': 'application/json',
        'Emergency': id,
      },
      redirect: 'follow',
      referrerPolicy: 'no-referrer',
      body: JSON.stringify(actionType),
    }).then((response) => response.json()).then((response) => {
      //setStatus(response.status)
      setStatusCode(response.statusCode);
      setMessage(response.message);
      setDetail(response.detail);
      setData(response.data);
      const userAgent = navigator.userAgent || navigator.vendor || window.opera;
      if (a === 'navigation') {
        if (isMobile) {
          if (/android/i.test(userAgent)) {
            window.location = (`google.navigation:q=${lat},${lng}`);
          } else if (/iPad|iPhone|iPod/.test(userAgent)) {
            window.location = (`maps://app?daddr=${lat},${lng}`);
          }
        } else {
          window.open(
              `https://www.google.com/maps/search/?api=1&query=${lat},${lng}`);
        }
      } else if (a === 'call') {
        if (isMobile) {
          if (/android/i.test(userAgent)) {
            window.location = (`tel:${phone}`);
          } else if (/iPad|iPhone|iPod/.test(userAgent)) {
            window.location = (`telprompt:${phone}`);
          }
        } else {
          window.alert(`${phone}`);

        }

      }
    });

  };

  const handleTap = (a, e) => {
    e.preventDefault();
    action(a);
    //	console.log("qweryu");
  };

  const handleClick = (a, e) => {
    e.preventDefault();
    action(a);
  };

  useEffect(() => {
    fetch(`${apiUri}/api/getEmergency`, {
      method: 'GET',
      mode: 'cors',
      cache: 'no-cache',
      credentials: 'same-origin',
      headers: {
        'Content-Type': 'application/json',
        'Emergency': id,
      },
      redirect: 'follow',
      referrerPolicy: 'no-referrer',
    }).then((response) => response.json()).then((response) => {
      setLat(response.latitude);
      setLng(response.longitude);
      setName(response.name ? response.name : 'no name');
      setPhone(response.phone ? response.phone : 'no phone');
      setStatus(response.status);
    });

  }, []);

  const renderMap = useCallback(
      () => (lat && lng && name && phone ? (<>
        <GoogleMap
            defaultZoom={14}
            defaultCenter={{lat: lat, lng: lng}}
        >
          <Marker
              position={{lat: lat, lng: lng}}
              icon={{
                url: 'https://i.ibb.co/QFZK29y/marked-log.png',

                anchor: new window.google.maps.Point(17, 46),

                scaledSize: new window.google.maps.Size(37, 37),
              }}
          />
        </GoogleMap>
        <div className="card-person">
          <div className="card-content">
            <div
                class="content-header"
                style={{display: 'flex', justifyContent: 'space-between'}}
            >
              <div class="firts-column">
                <div className="person-name">{name}</div>
                {status ? (
                    <>
                      <div className="halo-status-message">has activated Halo
                      </div>
                      <div className="second-column online">• Live Location
                      </div>
                    </>
                ) : (
                    <>
                      <div className="halo-status-message-off">has cancelled
                        Halo
                      </div>
                      <div className="second-column offline">• Halo Offline
                      </div>
                    </>
                )}

              </div>


            </div>

            {phone !== 'no phone' && (<ReactTouchEvents
                onTap={(e) => handleTap('call', e)}
            >
              <button className="btn-call"
                      onClick={(e) => handleTap('call', e)}>
                CALL
              </button>
            </ReactTouchEvents>)}
            <ReactTouchEvents
                onTap={(e) => handleTap('navigation', e)}
            >
              <button className={'btn-directions' +
                  (phone !== 'no phone' ? '' : ' no-phone')}
                      onClick={(e) => handleClick('navigation', e)}>
                NAVIGATE
              </button>
            </ReactTouchEvents>
          </div>
        </div>

      </>) : (<></>)),
      [lat, lng, name, phone, status],
  );

  return (
      renderMap()
  );
}));

export default MapView;